export * from './img-loader.component';
